import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AddressSelectedEvent } from 'projects/shared/address-autocomplete-v2/address-autocomplete-v2.component';
import { TurboInsurancePropertyInfo } from '../../../models/turbo-insurance/get-quote-request.model';
import { EnumsService } from '../../../services/enums.service';


@Component({
    selector: 'turbo-insurance-property-info-editor',
    templateUrl: 'turbo-insurance-property-info-editor.component.html',
    standalone: false
})
export class TurboInsurancePropertyInfoEditorComponent implements OnInit {

  @ViewChild('addressForm') addressForm: NgForm | undefined;
  @ViewChild('zipCodeOfAddress', {static: false}) zipCodeOfAddress: ElementRef | undefined;
  @ViewChild('cityOfAddress', {static: false}) cityOfAddress: ElementRef | undefined;

  constructor(private readonly _enumsService: EnumsService) {
    this.propertyInfo = new TurboInsurancePropertyInfo();
  }

  @Input()
  propertyInfo: TurboInsurancePropertyInfo;

  @Input()
  showMonthsAtAddressField: boolean = true;

  setManuallyEnteredAddress(address: string) {
    this.propertyInfo.streetAddress1 = address;
  }

  onAddressSelected(e: AddressSelectedEvent) {
    this.propertyInfo.streetAddress1 = e.streetAddress || '';
    this.propertyInfo.city = e.city || '';
    const st = this.states.find(s => s.name?.toUpperCase() === e.state?.toUpperCase());
    this.propertyInfo.state = st ? st.value : (e.state || '');
    this.propertyInfo.zip = e.zipCode || '';
    window.setTimeout(() => this.cityOfAddress?.nativeElement?.focus(), 0);
    window.setTimeout(() => this.zipCodeOfAddress?.nativeElement?.focus(), 0);
  }

  validate = () => {
    this.addressForm?.form.markAllAsTouched();
    if (this.addressForm?.form.valid) {
        return true;
    }
    return false;
  }

  public get states() {
    return this._enumsService.states;
  }

  ngOnInit() { }
}
